import { Component, OnInit, Input, ElementRef, OnChanges, SimpleChanges, OnDestroy, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { TagsEcommerce } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/tags-eccomerce.interface';
import { ArticulosEcommerce, ArticulosGeneral, CategoriasWebMenu, EcommerceGenericoService, RemplazosMMax, ResultadosDeBusquedaInterface } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CheckboxCategorias, CheckboxSubcategoria } from '../etc/categoria-checkbox.interface';
import { MarianomGeneral } from '../marianom-general.service';
import { PaginadorMmaxComponent } from '../paginador-mmax/paginador-mmax.component';
import { ComboPromo } from 'projects/mariano-max/src/app/core/ecommerce-generico/class/combo-promo.class';


@Component({
  selector: 'lista-productos-view',
  templateUrl: './lista-productos-view.component.html',
  styleUrls: ['./lista-productos-view.component.scss'],

})

export class ListaProductosViewComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() articulosIn: ArticulosGeneral[]
  @Input() modelo: string;
  @Input() loading: boolean = false;

  @ViewChild('ofertasScroll') ofertasScrollRef: ElementRef<HTMLElement>;
  needsScrollOfertas: boolean = true;
  private ofertasResizeObserver?: ResizeObserver;

  nActCarrusel: number;
  ofertaSlide: OfertaSlide[];
  numeropaginas: number;
  numeropaginasOfertas: number;
  misreemplazo: RemplazosMMax[];
  reemplazo: CheckboxCategorias[];
  gaseosas: CheckboxCategorias[];
  myExtrasResultado: ResultadosDeBusquedaInterface;
  categoriasClickeables: CategoriaClickeable[];
  min: number;
  max: number;
  priceFilterOn: boolean;
  private _destroyed$: Subject<any>;
  cantidadArticulosActuales: number;
  articulosFiltrados: ArticulosGeneral[] = [];
  filtroElegidoNombre: string;
  searchTerm: string = '';
  private autoPlayInterval: any;
  usaBultos: string = 'N';
  usaLista: string = 'N';

  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private cdRef: ChangeDetectorRef) {
    this.categoriasClickeables = [];
    this._destroyed$ = new Subject();
    this.nActCarrusel = this.nActCarrusel || 0;
    this.ofertaSlide = [];
    this.reemplazo = [];
    this.misreemplazo = [];
    this.numeropaginas = 0;
    this.min = 0;
    this.max = 0;
    this.priceFilterOn = false;
    this.initFiltros();
    this.genServ.getPaginas().pipe(takeUntil(this._destroyed$)).subscribe({
      next: data => {
        this.numeropaginas = data;
        this.initFiltros();
      },
    });

    this.genServ.getPaginasOfertas().pipe(takeUntil(this._destroyed$)).subscribe({
      next: data => {
        this.numeropaginasOfertas = data;
      },
    });

    this.genServ.getTerminoDeIniciarCarro().subscribe({
      next: avisoTerminoDeCargar => {
        //console.log('getTerminoDeIniciarCarro', this.misreemplazo)
        this.genServ.getReemplazosProvider().pipe(takeUntil(this._destroyed$)).subscribe({
          next: data => {
            //console.log('getReemplazosProvider', data)
            let subcat: CheckboxSubcategoria[] = [];
            this.misreemplazo = data;
            this.misreemplazo.forEach(k => {
              subcat.push({
                nombre: k.nombre,
                activada: false,
                id: k.modo
              });
            });
            this.reemplazo.push({
              nombre: 'Reemplazo de productos',
              categorias: subcat
            });
            if (this.reemplazo && this.reemplazo[0] && this.reemplazo[0].categorias && this.reemplazo[0].categorias[0]) {
              this.serv.marcarFaltantesConRemplazo(this.reemplazo[0].categorias[0])
            }
          }
        });
      }
    })
    /*     this.servGeneral.getSeRealizoUnaBusquedaObservable().subscribe({
          next:seRealizoUnaBusqueda =>{
            this.reiniciarFiltroPrecios();
            this.articulosFiltrados = this.articulosIn.slice()
          }
        }) */
  }


  ngOnInit(): void {
    if (this.modelo === 'historialDetail') {
      console.log(this.articulos)
    }
    this.modelo = this.modelo || 'normal';

    this.genServ.returnUsaBultos().subscribe(data => {
      this.usaBultos = (data || 'N').toString().trim();
    });

    this.genServ.returnUsaLista().subscribe(data => {
      this.usaLista = (data || 'N').toString().trim();
    });

    let index = 0;
    this.articulosFiltrados = this.articulosIn.slice()
    this.articulos.forEach(k => {
      this.ofertaSlide.push({
        activado: false,
        id: this.genServ.generarid(3),
      })
      index++;
    })
    if (this.ofertaSlide.length > 0) {
      this.ofertaSlide[0].activado = true;
    }
    if (this.reemplazo && this.reemplazo[0] && this.reemplazo[0].categorias && this.reemplazo[0].categorias[0]) {
      //console.log("Esto es ngonInit de componente ",this.reemplazo, this.reemplazo[0].categorias[0])
      this.serv.marcarFaltantesConRemplazo(this.reemplazo[0].categorias[0])
    }

    if (this.modelo === 'promos-land') {
      this.autoPlayInterval = setInterval(() => {
        this.onNextClickPr();
      }, 12000);

    }
  }

  ngOnDestroy(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
    this.ofertasResizeObserver?.disconnect();
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log('cambios lista productos', changes)
    this.articulosFiltrados = this.articulosIn.slice();
    this.reiniciarFiltroPrecios();
    if (this.modelo === 'ofertas-land') {
      setTimeout(() => this.actualizarNecesidadScrollOfertas());
    }
  }

  ngAfterViewInit(): void {
    if (this.modelo !== 'ofertas-land') return;
    this.actualizarNecesidadScrollOfertas();
    if (typeof ResizeObserver !== 'undefined' && this.ofertasScrollRef) {
      this.ofertasResizeObserver = new ResizeObserver(() => this.actualizarNecesidadScrollOfertas());
      this.ofertasResizeObserver.observe(this.ofertasScrollRef.nativeElement);
    }
  }

  // Con pocas ofertas (entran sin necesitar scroll) se ocultan las flechas
  // y se centran en vez de quedar pegadas a la izquierda con espacio vacío al lado.
  private actualizarNecesidadScrollOfertas(): void {
    if (!this.ofertasScrollRef) return;
    const el = this.ofertasScrollRef.nativeElement;
    const necesita = el.scrollWidth > el.clientWidth;
    if (necesita !== this.needsScrollOfertas) {
      this.needsScrollOfertas = necesita;
      this.cdRef.markForCheck();
    }
  }

  get ofertas() {
    return this.genServ.getOfertas()
  };

  get tags() {
    if (this._cachedTags) return this._cachedTags;
    let resultado: TagsEcommerce[] = [];
    this.myExtrasResultado?.tagsEnbusqueda?.forEach((k, v) => {
      resultado.push(k);
    });
    this._cachedTags = resultado;
    return resultado;
  }
  private _cachedTags: TagsEcommerce[] | null = null;

  get numBusqueda() {

    return this.genServ.getNumBusqueda();
  }

  get fueBusquedaEscrita() {
    return this.genServ.getFueBusquedaEscrita();
  }

  get numOfertas() {
    return this.genServ.getNumPagOfertas();
  }

  get articulos(): ArticulosGeneral[] {
    return this.articulosIn || [];
  }

  /**
   * Combos distintos presentes en el carrito (resumendetail), para mostrar
   * el descuento del combo como una fila propia con la imagen/nombre de la
   * promo, en vez de repetir el precio total del combo en cada artículo.
   */
  get combosEnCarrito(): ComboPromo[] {
    const vistos = new Set<ComboPromo>();
    const combos: ComboPromo[] = [];
    this.articulos.forEach(articulo => {
      const promo = articulo.misPromo && articulo.misPromo[0];
      if (promo instanceof ComboPromo && !vistos.has(promo)) {
        vistos.add(promo);
        combos.push(promo);
      }
    });
    return combos;
  }

  trackByArticulo(index: number, item: ArticulosGeneral): string {
    return item.getNombreMarca() + item.getDescripCion() + item.getPresentacion();
  }

  trackBySubcat(index: number, item: CheckboxSubcategoria): string {
    return item.id + item.nombre;
  }

  trackByCate(index: number, item: CategoriaClickeable): string {
    return item.nombre;
  }

  filtrarArticulos() {
    this.articulosFiltrados = this.articulosIn.filter(
      articulo => {
        return this.pasaLosFiltros(articulo as ArticulosEcommerce)
      }
    )
    this.cantidadArticulosActuales = this.articulosFiltrados.length
    //console.log('filtrarArticulos',this.articulosFiltrados)
  }

  pasaLosFiltros(articulo: ArticulosEcommerce) {
    let passesPrice = true;
    let passesSearch = true;

    // Filtro de Precio
    let minimo = this.ngmin || -1;
    let maximo = this.ngmax || 9999999999;
    
    let precio = articulo.getFraccion() ? (articulo.getPrecioMayorista() * articulo.getFraccion()) : articulo.getPrecioMayorista();
    passesPrice = precio >= minimo && precio <= maximo;

    // Filtro de búsqueda específica (filtro sobre filtro)
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const term = this.searchTerm.toLowerCase().trim();
      const desc = (articulo.getDescripCion() || '').toLowerCase();
      const marca = (articulo.getNombreMarca() || '').toLowerCase();
      const codigo = (articulo.getCodigo() || '').toString().toLowerCase();
      
      passesSearch = desc.includes(term) || marca.includes(term) || codigo.includes(term);
    }

    return passesPrice && passesSearch;
  }

  private async initFiltros() {
    let mayorPrecio: CheckboxSubcategoria = {
      nombre: 'Mayor Precio',
      activada: false,
      id: '1',
    }
    let menorPrecio: CheckboxSubcategoria = {
      nombre: 'Menor Precio',
      activada: false,
      id: '0'
    }
    let marcaaz: CheckboxSubcategoria = {
      nombre: 'Nombre (ascendente)',
      activada: false,
      id: 'a'
    }
    let marcadecen: CheckboxSubcategoria = {
      nombre: 'Nombre (descendente)',
      activada: false,
      id: 'z'
    }
    this.gaseosas = [
      {
        nombre: 'Seleccione una opción',
        categorias: [mayorPrecio, menorPrecio, marcaaz, marcadecen]
      }
    ];

    this.genServ.getExtraResultadosProvider().pipe(takeUntil(this._destroyed$)).subscribe({
      next: data => {
        this.categoriasClickeables = [];
        this.myExtrasResultado = data || {
          totaldeArticulos: 0,
          textodebusqueda: '',
        };
        if (this.myExtrasResultado.categoria == undefined) {
          this.categoriasClickeables.push({ nombre: 'Busqueda', activable: false });
          if (this.myExtrasResultado.textodebusqueda) {
            this.categoriasClickeables.push({ nombre: this.myExtrasResultado.textodebusqueda, activable: false });
          }
        }
        else {
          this.categoriasClickeables.push({ nombre: 'Busqueda', activable: false });
          
          const catPadre = this.myExtrasResultado.categoria;
          this.categoriasClickeables.push({
            nombre: catPadre.nombre,
            activable: true,
            categoria: catPadre
          });

          // Si el texto de búsqueda es distinto al del padre, intentamos encontrar la subcategoría
          if (this.myExtrasResultado.textodebusqueda && this.myExtrasResultado.textodebusqueda !== catPadre.nombre) {
            let encontrada = false;
            catPadre.subCategorias?.forEach(k => {
              if (encontrada) return;
              
              // Caso 1: Búsqueda es la subcategoría directa
              if (k.nombre === this.myExtrasResultado.textodebusqueda) {
                this.categoriasClickeables.push({ nombre: k.nombre, activable: true, categoria: k });
                encontrada = true;
              } 
              else {
                // Caso 2: Búsqueda es una sub-subcategoría
                k.subCategorias?.forEach(tirdtier => {
                  if (encontrada) return;
                  if (tirdtier.nombre === this.myExtrasResultado.textodebusqueda) {
                    // Evitamos duplicar si el padre intermedio tiene el mismo nombre que el abuelo o el hijo
                    if (k.nombre !== catPadre.nombre && k.nombre !== tirdtier.nombre) {
                      this.categoriasClickeables.push({ nombre: k.nombre, activable: true, categoria: k });
                    }
                    this.categoriasClickeables.push({ nombre: tirdtier.nombre, activable: true, categoria: tirdtier });
                    encontrada = true;
                  }
                });
              }
            });
          }
        }
      },
    });
  }

  clickOnCate(marca: CategoriasWebMenu, actiable: boolean) {
    marca.desplegado = false;
    if (actiable) {
      this.genServ.iniciarbusquedaPorCodigoMarca(marca, this.myExtrasResultado.categoria);
    }
  }

  categoriaSelec(event: CheckboxSubcategoria) {
    console.log('categoria selec')
    this.serv.marcarCarroConRemplazo(event)

  }

  seleccionadoFiltro(filtro: CheckboxSubcategoria) {
    if (this.gaseosas && this.gaseosas[0]) {
      this.gaseosas[0].categorias.forEach(k => {
        k.activada = false;
      });
      this.gaseosas[0].nombre = filtro.nombre;
    }
    filtro.activada = true;
    this.genServ.ordenarArticulosPor(filtro.id, filtro);
    this.genServ.cambiarPaginaElegida();
    this.filtroElegidoNombre = filtro.nombre;
  }


  cerrarTag(tag: TagsEcommerce) {
    if (tag.selecionado) {
      tag.selecionado = false;
      this.genServ.cerrartag(tag)
    }
    else {
      tag.selecionado = true;
      this.genServ.filtrarTag(tag)
    }

  }

  onPageSelect(event) {
    this.genServ.cambiarPagina(event);
    if (this.gaseosas && this.gaseosas[0]) {
      this.gaseosas[0].categorias.forEach(k => {
        if (k.activada) {
          this.seleccionadoFiltro(k);
        }
      })
    }
  }

  onPageSelectOferta(event) {
    this.genServ.cambiarPagina(event);
  }

  private async desactivarOfertas(index: string) {
    let sape = 0;
    this.ofertaSlide.forEach(k => {
      if (k.id === index) {
        k.activado = true;
        this.nActCarrusel = sape;
      }
      else {
        k.activado = false;
      }
      sape++;
    });

  }

  onPreviousClickPr() {
    const div = document.getElementById('slimarticulosPromos');
    div.scrollLeft -= 327;
  }

  onNextClickPr() {
    const div = document.getElementById('slimarticulosPromos');
    if (div) {
      const isAtEnd = div.scrollLeft + div.clientWidth >= div.scrollWidth - 10;
      if (isAtEnd) {
        div.scrollLeft = 0;
      } else {
        div.scrollLeft += 327;
      }
    }
  }

  onPreviousClickOf() {
    const div = document.getElementById('slimarticulosOfertas');
    div.scrollLeft -= 327;
  }

  onNextClickOf() {
    const div = document.getElementById('slimarticulosOfertas');
    if (div) {
      const isAtEnd = div.scrollLeft + div.clientWidth >= div.scrollWidth - 10;
      if (isAtEnd) {
        div.scrollLeft = 0;
      } else {
        div.scrollLeft += 327;
      }
    }
  }

  onchange(item: OfertaSlide) {
    this.desactivarOfertas(item.id);

  }

  anchoPag() {
    let ancho = document.getElementById("articulos");
    this.genServ.getAnchoPagina(ancho.clientWidth);
  }

  precioMin() {
    this.min = parseInt((<HTMLInputElement>document.getElementById("precioMin")).value);
  }

  precioMax() {
    this.max = parseInt((<HTMLInputElement>document.getElementById("precioMax")).value);
  }

  ngmin: number = 0;
  ngmax: number = 99999;


  reiniciarFiltroPrecios() {
    this.ngmin = null;
    this.ngmax = null;
  }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }

  permiteBultosEnListado(): boolean {
    const usaBultosActual = (this.usaBultos || 'N').toString().trim();
    const usaListaActual = (this.usaLista || 'N').toString().trim();

    if (usaBultosActual === 'S') {
      return true;
    }

    if (usaBultosActual === 'L') {
      return usaListaActual === 'S';
    }

    return false;
  }
}

interface OfertaSlide {
  activado: boolean,
  id: string,
}
interface CategoriaClickeable {
  nombre: string,
  categoria?: CategoriasWebMenu,
  activable: boolean;
}
